import React from 'react'
import { useNavigate } from 'react-router-dom'
import { navigateService } from '../../services/navigate.service'
import { routeService } from '../../services/route.service'

export default function AppHeaderLogoComponent() {
    const navigate = useNavigate()

    function handleGoToHomePage() {

        navigateService.handleNavigation(navigate, routeService.HOME)

    }

    return (
        <img src="https://haatdaas.lan-wan.net/daas/images/logo.svg" alt="Company Logo" className="h-8 w-20" onClick={handleGoToHomePage} />

    )
}
